import React, { Suspense } from "react";
import { Route, Routes } from "react-router-dom";
import Inicio from "../../views/Inicio/Inicio";
import MonitoreoServicios from "../../views/monitoreo/MonitoreoServicios/MonitoreoServicios";
import TransferirServicios from "../../views/monitoreo/TransferirServicios/TransferirServicios";
import VistaProgramados from "../../views/monitoreo/VistaProgramados/VistaProgramados";
import Bitacoras from "../../views/monitoreo/Bitacoras/Bitacoras";
import ProgramacionDeServicio from "../../views/programacion/ProgramacionDeServicio/ProgramacionDeServicio";
import Exepciones from "../../views/programacion/Exepciones/Exepciones";
import Esquemas from "../../views/programacion/Esquemas/Esquemas";
import ApolloOperadores from "../../views/programacion/ApolloOperadores/ApolloOperadores";
import Precios from "../../views/precios/Precios";
import Administrador from "../../views/Administrador/Administrador";
import AministradorTabla from "../../views/Administrador/AministradorTabla/AministradorTabla";
import EditarEsquema from "../../views/programacion/Esquemas/EditarEsquema/EditarEsquema";
import CrearEsquema from "../../views/programacion/Esquemas/CrearEsquema/CrearEsquema";
import Tablero from "../../views/monitoreo/Tablero/Tablero";
import ProgramacionMasiva from "../../views/programacion/ProgramacionMasiva/ProgramacionMasiva";
import VerIncidencias from "../../views/monitoreo/VerIncidencias/VerIncidencias";
import CrearRutas from "../../views/programacion/Rutas/Rutas";
import SolicitudDeReembolso from "../../views/monitoreo/VerIncidencias/SolicitudDeReembolso";
import MaestroDeServicios from "../../views/programacion/MaestroDeServicios/MaestroDeServicios";
import Reportes from "../../views/Reportes/Reportes";
import Notas from "../../views/Reportes/Notas/Notas";
import BitacorasPorTurno from "../../views/monitoreo/BitacorasPorTurno/BitacorasPorTurno";
import ServiciosEnVivo from "../../views/monitoreo/ServiciosEnVivo/ServiciosEnVivo";
import CierreDeTurno from "../../views/monitoreo/CierreDeTurno/CierreDeTurno";

const RouterAuth = () => {
    return (
        <Routes>
            <Route exact path="/" element={<Suspense fallback={<>Skeleton</>}>
                <Inicio></Inicio>
            </Suspense>} />
            <Route exact path="/monitoreo/monitoreo-de-servicios" element={<Suspense fallback={<>Skeleton</>}>
                <MonitoreoServicios></MonitoreoServicios>
            </Suspense>} />
            <Route exact path="/monitoreo/transferir-servicios" element={<Suspense fallback={<>Skeleton</>}>
                <TransferirServicios></TransferirServicios>
            </Suspense>} />
            <Route exact path="/monitoreo/vista-programados" element={<Suspense fallback={<>Skeleton</>}>
                <VistaProgramados></VistaProgramados>
            </Suspense>} />
            <Route exact path="/monitoreo/bitacoras" element={<Suspense fallback={<>Skeleton</>}>
                <Bitacoras></Bitacoras>
            </Suspense>} />
            <Route exact path="/monitoreo/tablero" element={<Suspense fallback={<>Skeleton</>}>
                <Tablero></Tablero>
            </Suspense>} />
            <Route exact path="/monitoreo/ver-incidencias" element={<Suspense fallback={<>Skeleton</>}>
                <VerIncidencias></VerIncidencias>
            </Suspense>} />
            <Route exact path="/monitoreo/solicitud-reembolso/:id_incidente" element={<Suspense fallback={<>Skeleton</>}>
                <SolicitudDeReembolso></SolicitudDeReembolso>
            </Suspense>} />
            <Route exact path="/monitoreo/bitacoras-por-turno" element={<Suspense fallback={<>Skeleton</>}>
                <BitacorasPorTurno></BitacorasPorTurno>
            </Suspense>} />
            <Route exact path="/monitoreo/servicios-en-vivo" element={<Suspense fallback={<>Skeleton</>}>
                <ServiciosEnVivo></ServiciosEnVivo>
            </Suspense>} />

            {/* ------------------------------------------------------------------------------------------------------------------------------------------ */}

            <Route exact path="/programacion/maestro-de-servicios" element={<Suspense fallback={<>Skeleton</>}>
                <MaestroDeServicios></MaestroDeServicios>
            </Suspense>} />
            <Route exact path="/programacion/programacion-de-servicios" element={<Suspense fallback={<>Skeleton</>}>
                <ProgramacionDeServicio></ProgramacionDeServicio>
            </Suspense>} />
            <Route exact path="/programacion/exepciones" element={<Suspense fallback={<>Skeleton</>}>
                <Exepciones></Exepciones>
            </Suspense>} />
            <Route exact path="/programacion/esquemas" element={<Suspense fallback={<>Skeleton</>}>
                <Esquemas></Esquemas>
            </Suspense>} />
            <Route exact path="/programacion/esquemas/editar/:id_esquema" element={<Suspense fallback={<>Skeleton</>}>
                <EditarEsquema></EditarEsquema>
            </Suspense>} />
            <Route exact path="/programacion/esquemas/crear" element={<Suspense fallback={<>Skeleton</>}>
                <CrearEsquema></CrearEsquema>
            </Suspense>} />
            <Route exact path="/programacion/programacion-masiva" element={<Suspense fallback={<>Skeleton</>}>
                <ProgramacionMasiva></ProgramacionMasiva>
            </Suspense>} />
            <Route exact path="/programacion/rutas" element={<Suspense fallback={<>Skeleton</>}>
                <CrearRutas></CrearRutas>
            </Suspense>} />
            {/* <Route exact path="/programacion/apoyo-operadores" element={<Suspense fallback={<>Skeleton</>}>
                <ApolloOperadores></ApolloOperadores>
            </Suspense>} /> */}
            {/* ------------------------------------------------------------------------------------------------------------------------------------------- */}
            <Route exact path="/precios" element={<Suspense fallback={<>Skeleton</>}>
                <Precios></Precios>
            </Suspense>} />

            {/* ------------------------------------------------------------------------------------------------------------------------------------------- */}
            <Route exact path="/administrador" element={<Suspense fallback={<>Skeleton</>}>
                <AministradorTabla></AministradorTabla>
            </Suspense>} />
            <Route exact path="/administrador/editar/:id_usuario/:id_modulo" element={<Suspense fallback={<>Skeleton</>}>
                <Administrador editar={true}></Administrador>
            </Suspense>} />
            <Route exact path="/administrador/agregar" element={<Suspense fallback={<>Skeleton</>}>
                <Administrador editar={false}></Administrador>
            </Suspense>} />
            <Route exact path="/*" element={<Suspense fallback={<>Skeleton</>}>
                <h1>404 Pagina no encontrada</h1>
            </Suspense>} />

            {/* ------------------------------------------------------------------------------------------------------------------------------------------- */}
            <Route exact path="/reportes/graficas" element={<Suspense fallback={<>Skeleton</>}>
                <Reportes></Reportes>
            </Suspense>} />
            <Route exact path="/reportes/notas" element={<Suspense fallback={<>Skeleton</>}>
                <Notas></Notas>
            </Suspense>} />
            {/* ------------------------------------------------------------------------------------------------------------------------------------------- */}
            <Route exact path="/monitoreo/cierre-de-turno" element={<Suspense fallback={<>Skeleton</>}>
                <CierreDeTurno></CierreDeTurno>
            </Suspense>} />


        </Routes>
    )
}
export default RouterAuth